module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zoom-control">\n    <span class="zoom-percent">100%</span>\n    <button class="zoom-out btn-clear" title="Zoom out [-]">&minus;</button>\n    <button class="zoom-in btn-clear" title="Zoom in [+]">+</button>\n    <button class="reset-zoom btn-clear" title="Zoom to 100% [0]">reset</button>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/ZoomView.tpl
// module id = 3019
// module chunks = 0